/**
 * @deprecated
 */
/**
 * @deprecated
 *
 * Determine if a property has and should display a rich media video
 * @param property
 * @param abTests
 * @returns
 */

function shouldShowVideo() {
  return false;
}

// eslint-disable-next-line zillow/import/no-extraneous-dependencies

/**
 * @deprecated
 */
var ShouldShowVideoFragment = {
  property: {
    "kind": "Document",
    "definitions": [{
      "kind": "FragmentDefinition",
      "name": {
        "kind": "Name",
        "value": "ShouldShowVideo_property"
      },
      "typeCondition": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "Property"
        }
      },
      "directives": [],
      "selectionSet": {
        "kind": "SelectionSet",
        "selections": [{
          "kind": "Field",
          "name": {
            "kind": "Name",
            "value": "zpid"
          },
          "arguments": [],
          "directives": []
        }]
      }
    }],
    "loc": {
      "start": 0,
      "end": 88,
      "source": {
        "body": "\n        fragment ShouldShowVideo_property on Property {\n            zpid\n        }\n    ",
        "name": "GraphQL request",
        "locationOffset": {
          "line": 1,
          "column": 1
        }
      }
    }
  }
};

export { ShouldShowVideoFragment, shouldShowVideo };
